module.exports = __webpack_public_path__ + "static/img/evolucao-sentimento-linhas.6a3112a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/evolucao-sentimento-linhas.png
// module id = WbGC
// module chunks = 1